import * as actionsTypes from './actions';

const initialState = {
    isLoading: false,
    allDevices: {},
}

export default function (state = { ...initialState }, action) {
    switch (action.type) {

        case actionsTypes.GET_ALL_DATAFORCE_AGENCY_DEVIECS_REQUEST:
            return { ...state, isLoading: true }

        case actionsTypes.GET_ALL_DATAFORCE_AGENCY_DEVIECS_SUCCESS:
            return { ...state, isLoading: false, allDevices: action.payload || {} }

        case actionsTypes.GET_ALL_DATAFORCE_AGENCY_DEVIECS_FAILED:
            return { ...state, isLoading: false }

        case actionsTypes.CLEAR_ALL_DATAFORCE_AGENCY_DEVICE_DATA:
            return { ...state, ...initialState }

        default:
            return state
    }
}